import Vue from "vue";
import Vuex from "vuex";
import PrizeService from "@/services/PrizeService.js";
import device from "@/store/device.js";
import general from "@/store/general.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    prize: {
      id: "",
    },
  },
  mutations: {
    SET_PRIZE(state, data) {
      state.prize = data;
    },
  },
  actions: {
    getPrize({ commit }) {
      return PrizeService.getPrize()
        .then((result) => {
          // console.log(result.data.status);
          if (result.data.status == "200") {
            commit("SET_PRIZE", result.data);
          } else {
            //TODO: if status isn't 200, how do we handle
          }
        })
        .catch((error) => {
          // console.log("ERROR getting coupon code");// just gonna trigger the no more coupons
          commit("SET_PRIZE", { status: "NA", couponCode: false });
        });
    },
  },
  modules: {
    device: device,
    general: general,
  },
});
